import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/financial_management',
  component: Layout,
  name: 'financialManagement',
  meta: {
    title: '财务管理',
    icon: 'i-ant-design:account-book-outlined',
  },
  children: [
    {
      path: 'usdt_recharge',
      name: 'financialManagementUsdtRecharge',
      component: () => import('@/views/financial_management/usdt_recharge.vue'),
      meta: {
        title: 'USDT链上充值',
        icon: 'i-ant-design:arrow-down-outlined',
      },
    },
    {
      path: 'usdt_withdrawal',
      name: 'financialManagementUsdtWithdrawal',
      component: () => import('@/views/financial_management/usdt_withdrawal.vue'),
      meta: {
        title: 'USDT链上提现',
        icon: 'i-ant-design:arrow-up-outlined',
      },
    },
    {
      path: 'manual_recharge',
      name: 'financialManagementManualRecharge',
      component: () => import('@/views/financial_management/manual_recharge.vue'),
      meta: {
        title: '手动充值明细',
        icon: 'i-ant-design:edit-outlined',
      },
    },
    {
      path: 'points_distribution',
      name: 'financialManagementPointsDistribution',
      component: () => import('@/views/financial_management/points_distribution.vue'),
      meta: {
        title: '上下分明细',
        icon: 'i-ant-design:partition-outlined',
      },
    },
    {
      path: 'reward_gift',
      name: 'financialManagementRewardGift',
      component: () => import('@/views/financial_management/reward_gift.vue'),
      meta: {
        title: '奖励赠送明细',
        icon: 'i-ant-design:gift-outlined',
      },
    },
  ],
}

export default routes
